import * as actionTypes from './actionTypes';

export const requestInvoices = ({ qs } = {}) => ({
  type: actionTypes.REQUEST_INVOICES,
  qs,
});

export const requestUserTransactions = () => ({
  type: actionTypes.REQUEST_USER_TRANSACTIONS,
});

export const requestSubscriptionPlans = () => ({
  type: actionTypes.REQUEST_SUBSCRIPTION_PLANS,
});

export const requestCurrentCustomer = () => ({
  type: actionTypes.REQUEST_CURRENT_CUSTOMER,
});

export const requestPaymentAttempt = callbacks => ({
  type: actionTypes.REQUEST_PAYMENT_ATTEMPT,
  callbacks,
});

export const requestSetPlan = ({ data, callbacks }) => ({
  type: actionTypes.REQUEST_SET_PLAN,
  data,
  callbacks,
});

export const requestPaymentIntentsSetup = () => ({
  type: actionTypes.REQUEST_PAYMENT_INTENTS_SETUP,
});

export const requestGetPaymentMethods = ({ callbacks } = {}) => ({
  type: actionTypes.REQUEST_GET_PAYMENT_METHODS,
  callbacks,
});

export const requestCreatePaymentMethod = ({ qs, body, callbacks }) => ({
  type: actionTypes.REQUEST_CREATE_PAYMENT_METHOD,
  qs,
  body,
  callbacks,
});

export const requestDeletePaymentMethod = ({ id, callbacks }) => ({
  type: actionTypes.REQUEST_DELETE_PAYMENT_METHOD,
  id,
  callbacks,
});

export const requestSetDefaultPaymentMethod = ({ id, callbacks }) => ({
  type: actionTypes.REQUEST_SET_DEFAULT_PAYMENT_METHOD,
  id,
  callbacks,
});

export const cancelSubscriptionRequest = ({ id, callbacks }) => ({
  type: actionTypes.CANCEL_SUBSCRIPTION_REQUEST,
  id,
  callbacks,
});

export const setDefaultCardRequest = card => ({
  type: actionTypes.SET_DEFAULT_CARD_REQUEST,
  card,
});

export const addCardRequest = (cardToken, callbacks) => ({
  type: actionTypes.ADD_CARD_REQUEST,
  cardToken,
  callbacks,
});

export const deleteCardRequest = cardId => ({
  type: actionTypes.DELETE_CARD_REQUEST,
  cardId,
});

export const setSubscription = subscription => ({
  type: actionTypes.SET_SUBSCRIPTION,
  payload: {
    subscription,
  },
});

export const setPaymentState = payload => ({
  type: actionTypes.SET_PAYMENT_STATE,
  payload,
});

export const requestCreateInvoice = ({ payload, callbacks }) => ({
  type: actionTypes.REQUEST_CREATE_INVOICE,
  payload,
  callbacks,
});
